<template>

    <div class="container">

        <div class="handle-box-search">

            <el-row class="head-search">


                <el-col :span="12">
                    <span class="title">订单编号:</span>
                    <!-- 搜索名称 -->
                    <el-input v-model="search_data.billno" placeholder="请输入订单编号" class="handle-input mr10"
                        @keyup.enter.native="searchcardLists"></el-input>
                </el-col>

                <el-col :span="12">
                    <span class="title">乘客电话:</span>
                    <!-- 搜索名称 -->
                    <el-input v-model="search_data.consumer_phone" placeholder="请输入乘客电话" class="handle-input mr10"
                        @keyup.enter.native="searchcardLists"></el-input>
                </el-col>



            </el-row>


            <el-row class="head-search">


                <el-col :span="24" style="margin-bottom: 10px;">
                    <span class="title">下单时间:</span>

                    <el-date-picker v-model="order_fixed_array" type="datetimerange" range-separator="-"
                        start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="orderTimeChange" style="width: 350px;">
                    </el-date-picker>
                </el-col>



            </el-row>

            <el-row class="head-search">


                <el-col :span="24" style="margin-bottom: 10px;">
                    <span class="title">完成时间:</span>

                    <el-date-picker v-model="finish_fixed_array" type="datetimerange" range-separator="-"
                        start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss" @change="finishTimeChange" style="width: 350px;">
                    </el-date-picker>
                </el-col>



            </el-row>

            <el-button type="primary" icon="el-icon-search" @click="searchcardUseRecord">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button v-if="loading" icon="el-icon-loading" disabled></el-button>
            <el-button @click="toExport" v-else>导出</el-button>
            <div style="width: 500px; margin: 10px auto;" v-if="progress_show">

                <el-progress :percentage="progress_data"></el-progress>
                <i class="el-icon-loading"></i>
                正在导出...

            </div>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55">
            </el-table-column>
            <el-table-column prop="consumer_phone" min-width="180" label="用户手机号">
            </el-table-column>
            <el-table-column prop="order_time" min-width="180" label="下单时间">
            </el-table-column>

            <el-table-column prop="card_name" label="畅行卡名称" min-width="180">
            </el-table-column>

            <el-table-column prop="last_num" label="畅行卡剩余次数" min-width="180">
            </el-table-column>

            <el-table-column prop="used_num" label="畅行卡已使用次数" min-width="180">
            </el-table-column>

            <el-table-column prop="limit_num" label="畅行卡限制次数" min-width="180">
                <template slot-scope="scope">
                    <span>
                        {{scope.row.limit_num==0?'无限':scope.row.limit_num}}
                    </span>
                </template>
            </el-table-column>

            <el-table-column prop="billno" label="订单编号" min-width="180">
            </el-table-column>


            <el-table-column prop="predict_amount" label="预估计金额" min-width="180">
            </el-table-column>

            <el-table-column prop="amount" label="实际金额" min-width="180">
            </el-table-column>

            <el-table-column prop="finish_amount" label="实收金额" min-width="180">
            </el-table-column>

            <el-table-column prop="pay_channel" label="支付方式" min-width="180">
            </el-table-column>

            <el-table-column prop="pay_mode" label="付款通道" min-width="180">
            </el-table-column>

            <el-table-column prop="end_time_stamp" label="完成时间" min-width="180">
            </el-table-column>





            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" @click="toDetalis(scope.row.card_order_code)">查看</el-button>
                </template>
            </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>


        <!-- 详情组件 -->
        <detailsC :isShow="details_isShow" :data="card_order_code"></detailsC>

    </div>

</template>

<script>
    import detailsC from './details.vue';
    import bus from '@/components/common/bus.js';
    var _this;
    export default {
        components: {
            detailsC
        },

        data() {
            return {
                options_mode_code: [],
                // 下拉搜索模式
                value_mode_code: '',
                mode_options_data: {
                    page: 1,
                    limit: 5,
                    status: '1'
                },
                selectPages_data: [],

                excelData: [],

                excelHead: [],

                progress_show: false,
                progress_data: 0,

                loading: false,
                finish_fixed_array: '',
                order_fixed_array: '',

                details_isShow: false,

                card_order_code: '',

                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    billno: '',
                    consumer_phone: '',
                    finish_fixed_array: '',
                    order_fixed_array: '',
                    card_order_code_array: ''
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            bus.$on('btnStatus', (msg) => {
                _this.progress_show = msg;
            });
            _this.cardUseRecord()
        },

        methods: {

            selectPages_function(search_data) {
                _this.mode_options_data = search_data;

                _this.orderModeList();
            },

            orderModeList() {
                // 请求公司管理接口获取公司唯一编码
                _this
                    .$post('/order/orderModeLists', _this.mode_options_data)
                    .then((res) => {
                        _this.selectPages_data = res;
                        _this.options_mode_code = res.data;
                    })
                    .catch((err) => { });
            },

            //搜索的下拉框弹出触发
            modeVisibleChange(val) {
                _this.orderModeList();
            },
            modeChange(val) {
                _this.search_data.order_mode_code = val;
            },

            // 导出
            toExport() {

                _this.progress_show = true;
                _this.search_data.page = 1;
                _this.getExcelData();


            },

            getExcelData() {

                _this.$post(
                    "/card/cardUseRecord",
                    _this.search_data
                ).then(res => {

                    _this.progress_show = true;

                    if (this.$route.path == '/usagRecord') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.length; i++) {
                            console.log(res.data[i].order_code);
                            _this.excelData.push({
                                'consumer_phone': res.data[i].consumer_phone,
                                'order_time': res.data[i].order_time,
                                'card_name': res.data[i].card_name,
                                'last_num': res.data[i].last_num,
                                'used_num': res.data[i].used_num,
                                'limit_num': res.data[i].limit_num == 0 ? '无限' : res.data[i].limit_num,
                                'billno': res.data[i].billno,
                                'predict_amount': res.data[i].predict_amount,
                                'amount': res.data[i].amount,
                                'finish_amount': res.data[i].finish_amount,
                                'pay_channel': res.data[i].pay_channel,
                                'pay_mode': res.data[i].pay_mode,
                                'end_time_stamp': res.data[i].end_time_stamp,

                            });


                        }



                        if (_this.search_data.page * _this.search_data.limit < res.count) {

                            _this.search_data.page = _this.search_data.page + 1;

                            _this.progress_data = Math.floor((_this.search_data.page * _this.search_data.limit / res.count) * 100);

                            _this.getExcelData();

                        } else {

                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;
                            _this.progress_data = 0;


                        }

                    } else {

                        _this.progress_show = false;
                        _this.progress_data = 0;

                    }



                }).catch((err) => {

                })

            },


            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['用户手机号', '下单时间', '畅行卡名称', '畅行卡剩余次数', '畅行卡已使用次数', '畅行卡限制次数', '订单编号', '预估计金额', '实际金额', '实收金额', '支付方式', '付款通道', '完成时间'];


                const filterVal = ['consumer_phone', 'order_time', 'card_name', 'last_num', 'used_num', 'limit_num', 'billno', 'predict_amount', 'amount', 'finish_amount', 'pay_channel', 'pay_mode', 'end_time_stamp'
                ];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                let time = new Date();
                console.log(time);
                console.log(time.toLocaleDateString());
                export_json_to_excel(tHeader, data, '畅行卡使用记录'+time.toLocaleDateString());
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]));
            },


            // 全选或多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
                console.log(this.multipleSelection);

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].card_order_code);

                }
                _this.search_data.card_order_code_array = datalist;
                console.log(datalist);

            },

            toDetalis(code) {
                console.log(111);
                _this.details_isShow = !_this.details_isShow;
                _this.card_order_code = code;

            },


            orderTimeChange(val) {
                if (val !== null) {
                    _this.search_data.order_fixed_array = JSON.stringify(['between'].concat(val));

                } else {
                    _this.search_data.order_fixed_array = ''
                }

            },
            finishTimeChange(val) {
                if (val !== null) {
                    _this.search_data.finish_fixed_array = JSON.stringify(['between'].concat(val));

                } else {
                    _this.search_data.finish_fixed_array = ''
                }
            },
            searchcardUseRecord() {


                _this.search_data.page = 1;
                _this.cardUseRecord();

            },
            // 搜索司机日志列表
            cardUseRecord() {

                _this.$post(
                    "/card/cardUseRecord",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;


                    }).catch((err) => {

                    })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.cardUseRecord();

            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>